module.exports = __webpack_public_path__ + "img/partyterminal1.0ce7588f.png";